import AppSettings from "../../AppSettings";
import { sendAccountNotification } from "./SlackNotification";
import { PostAccountRequest } from "../../requests/PostRequest";

async function SendEmail(email) {
  const endpoint = AppSettings.EmailRequest;
  console.log(`Sending email: ${email.Subject} to ${email.To} from ${email.From} using ${endpoint}`);
  await fetch(endpoint, {
    method: "post",
    headers: {
      // You'd think we'd by sending Content-Type application/json, but doing so causes a preflight check
      // https://dev.to/effingkay/cors-preflighted-requests--options-method-3024
      // Which wouldn't be so bad, but the associated OPTIONS request was generating an error on chrome
      // https://stackoverflow.com/questions/45468033/err-spdy-protocol-error-ajax-net-web-api
      // We think this has something to do with Chrome upgrading the request to HTTP/2, but we punted.
      // FYI, disabling HTTP2 in Chrome allowed us to POST with application/json with no error
      // https://stackoverflow.com/questions/42435786/how-to-disable-http-2-in-chrome-or-chromium
      "Content-Type": "text/plain"
    },
    body: JSON.stringify(email)
  });
  console.log(`Sent email: ${email.Subject}`);
}

async function sendRequestEmail(subject, message) {
  await SendEmail({
    To: AppSettings.Email.QuoteTo,
    From: AppSettings.Email.QuoteFrom,
    Subject: `${AppSettings.IsProd ? "" : "[TEST] "}${subject}`,
    Message: `${message}<p><i>Submitted from: ${AppSettings.AppVersion}</i></p>`,
    IsHtml: true,
    Cc: AppSettings.Email.AccountTo,
    Bcc: AppSettings.Email.QuoteBcc
  });
}

async function sendAcknowledmentEmail(to, subject, message) {
  await SendEmail({
    To: `${to}`,
    From: AppSettings.Email.AccountReceiptFrom,
    Subject: `${AppSettings.IsProd ? "" : "[TEST] "}${subject}`,
    Message: `${message}`,
    IsHtml: true,
    Cc: "",
    Bcc: AppSettings.Email.ReceiptBcc
  });
}

export default async function SubmitAccountRequest(request, onSubmit, resetForm, token) {
  try {
    const requestId = await PostAccountRequest(
      "", // No account
      "", // No company
      request.name,
      request.email,
      request.phone,
      `Follow-up in a couple days if they haven't yet submitted paperwork`,
      token
    );
    const subject = `Account Request by ${request.name} ref:${requestId}`;
    await sendRequestEmail(
      subject,
      `<p>The person below visited our website and requested information about setting up a trade account: </p>
    <p>${request.name}<br/>${request.email}<br/>${request.phone}
    <p><b>A/R</b>: If ${
      request.name
    } submits the paperwork, please complete request <a href="${AppSettings.RequestStatusPage(
        requestId
      )}">${requestId}</a></p>
    <p><b>Sales</b>: If we haven't heard back from ${
      request.name
    } in a couple days, please follow-up on request <a href="${AppSettings.RequestStatusPage(
        requestId
      )}">${requestId}</a>
    <br/>Note that there is a template email for this purpose in Chrome.</p>`
    );
    await sendAcknowledmentEmail(
      request.email,
      "Creating a trade account with Case Parts",
      `<p>Dear ${request.name},</p>
			 <p>New customers are often amazed to learn that Case Parts has no credit application and will generally open
			 a Net 30 day account over the phone. We trust our trade customers to honor their obligations much in the same
			 way our customers trust us to provide them with prompt professional service. It's our philosophy that mutual
			 trust is basis of all successful business relationships and we see our "no hassle" credit policy as the first
			 way we demonstrate our commitment to our customers.</p><p>All we ask is that you <b>complete our one-page
			 <a href='${AppSettings.TradeApplication}'>Trade Account Application</a></b>	and fax it along with a copy of 
			 your business license and/or contractors' license and state sales tax exemption certificate as appropriate to 
			<b>(800) 972-2441</b>, attention: <b>New Accounts</b>,</p>
			<p>If we receive your application during business hours (M-F 7:30AM - 5:00PM PT), we can usually open your account the same day!</p>
			<p>Feel free to call me directly at the number below if you have any questions.</p>
			<p>Thank you!</p><p>Pam Salgado<br/>Accounts Receivable Manager<br/>(800) 421-0271x133<br/>ref:${requestId}</p>`
    );
    await sendAccountNotification(`Account Request by ${request.name}`, request, requestId);
    onSubmit();
    resetForm();
  } catch (error) {
    onSubmit(error);
  }
}
